import HistoryIndexCell from "./HistoryIndexCell";

class HistoryIndex {
    constructor() {
        this.data = [];
        this.name = "";
        this.md5 = "";
    }

    getContentJson() {        
        let json = JSON.stringify(this, function (key, val) {
            if (typeof val === "function") {
                return val + '';
            }
            return val
        });
        return json;
    }

    format(json) {
        let historyIndex = new HistoryIndex()
        let data = JSON.parse(json)
        for (var key in data) {
            let keyValue = data[key]
            if (key == "data") {
                var list = []
                 for (let index = 0; index < keyValue.length; index++) {
                    let jsonDataCell = keyValue[index]
                    let cell = new HistoryIndexCell();
                    cell.time = jsonDataCell.time;
                    cell.fileName = jsonDataCell.fileName;
                    cell.md5 = jsonDataCell.md5 == null ? "" : jsonDataCell.md5
                    list.push(cell);
                 }
                 historyIndex.data = list
            } else {
                historyIndex[key] = keyValue
            }
        }
        return historyIndex
    }
}

export default HistoryIndex